import React, { FunctionComponent, ChangeEvent } from "react";
import PropTypes from "prop-types";
import Theme from "../../../theme/theme";
import { StyledLabel, StyledInput, StyledIndicator } from "./styles";

export interface CheckboxProps {
  disabled?: boolean;
  /**
   * Checkbox name - used to identify in state
   */
  name: string;
  /**
   * Checkbox label - used as value too
   */
  label: string;
  checked?: boolean;
  /**
   * onChange function - returns event
   */
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const Checkbox: FunctionComponent<CheckboxProps> = ({
  disabled,
  label,
  checked,
  onChange,
  name,
}) => (
  <Theme>
    <StyledLabel>
      <StyledInput
        type="checkbox"
        aria-label={label}
        name={name}
        id={name}
        value={label}
        disabled={disabled || false}
        checked={checked}
        onChange={onChange}
      />
      {label}
      <StyledIndicator />
    </StyledLabel>
  </Theme>
);

Checkbox.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

Checkbox.defaultProps = {
  disabled: null,
  checked: null,
};

export default Checkbox;
